const UserCircle = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.6056 25.5253L24.3266 25.7472C21.7661 27.783 18.5229 29 14.9982 29C11.4735 29 8.23017 27.783 5.66961 25.7471L5.39062 25.5253L5.42676 25.463C7.32003 22.1963 10.9017 20 14.9981 20C19.0946 20 22.6762 22.1963 24.5695 25.463L24.6056 25.5253Z"
        fill={color}
      />
      <path
        d="M15 18C17.4853 18 19.5 15.9853 19.5 13.5C19.5 11.0147 17.4853 9 15 9C12.5147 9 10.5 11.0147 10.5 13.5C10.5 15.9853 12.5147 18 15 18Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 2C7.8203 2 2 7.8203 2 15C2 22.1797 7.8203 28 15 28C22.1797 28 28 22.1797 28 15V14H30V15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C18.2262 0 21.2172 1.01963 23.6645 2.75413L24.5473 3.37981L23.1634 5.03834L21.8804 3.9678C19.8852 2.72065 17.528 2 15 2Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5 5.5C21.5 3.567 23.067 2 25 2C26.933 2 28.5 3.567 28.5 5.5C28.5 7.433 26.933 9 25 9C23.067 9 21.5 7.433 21.5 5.5Z"
        fill={color}
      />
    </svg>
  );
};
export default UserCircle;
